import { useRouter } from 'next/router';
import { isRedesignChatRoute } from 'root/src/client/v2/layout/helpers/redesignRoutes';
// The bottom-right floating stack, bottom-up: the live chat launcher, the Discord button, then any
// page-level widget on top of them (the drop page's admin "Live view" toggle).
//
// Every widget in the stack is the same size and every slot is the same distance apart, so the whole
// geometry is these three numbers plus a slot index. Widgets take `bottom` from here as an inline
// style rather than a Tailwind class, because the slot positions fall between the spacing scale's
// steps and arbitrary `bottom-[...]` classes would hide the arithmetic.
export const FLOATING_WIDGET_SIZE = 48;
const CORNER_INSET = 24;
const SLOT_GAP = 16;
const slotBottom = (slot) => CORNER_INSET + slot * (FLOATING_WIDGET_SIZE + SLOT_GAP);
// Shared presentation of a stack widget: the button box and the icon inside it.
export const FLOATING_WIDGET_SIZE_CLASS = 'h-12 w-12';
export const FLOATING_WIDGET_ICON_CLASS = 'h-6 w-6';
// Horizontal inset shared by every slot.
export const FLOATING_WIDGET_RIGHT_CLASS = 'right-4 sm:right-6';
// Bottom slot, the corner itself: the chat launcher, where the route has one.
export const CHAT_WIDGET_BOTTOM = slotBottom(0);
// True when the current redesign page renders the chat launcher.
const useHasChatWidget = () => {
    const { pathname } = useRouter();
    return isRedesignChatRoute(pathname);
};
// Discord button: above the chat launcher where there is one, in the corner otherwise.
export const useDiscordWidgetBottom = () => slotBottom(useHasChatWidget() ? 1 : 0);
// The slot directly above the Discord button.
export const useStackedWidgetBottom = () => slotBottom(useHasChatWidget() ? 2 : 1);
